<template>
  <div>
    <div class="show-title"><span>我们的优势</span></div>
    <div class="my-preponderance">
      <div class="my-preponderance-banner firstSheet">
        <div class="banner-desc">
          <div class="banner-desc-box">
            <p><span class="s-title">多方数据融合</span></p>
            <p class="s-title1">广告主第一方私有数据、合作第三方大数据（已涵盖7.5亿移动端用户数据）</p>
          </div>
          <div class="banner-desc-box">
            <p><span class="s-title">合作媒体数据全链条打通</span></p>
            <p class="s-title1">八大维度，涵盖合作媒体用户自然属性及行为兴趣……</p>
          </div>
          <div class="line "></div>
          <div class="title">用户数据全链条打通</div>
        </div>
      </div>
      <div class="my-preponderance-banner brain">
        <div class="banner-desc">
          <div class="banner-desc-box">
            <p><span class="s-title BgColor-two">理解用户（属性、标签等）</span></p>
            <p class="s-title1">DMP自定义人群包，灵活支持特色定向投放</p>
          </div>
          <div class="banner-desc-box">
            <p><span class="s-title BgColor-two">理解行为（行为场景、行为类型）</span></p>
            <p class="s-title1">数据拓展 Lookalike & 数据运算 交叉 | 合并 | 排除</p>
          </div>
          <div class="line BgColor-two"></div>
          <div class="title">用户兴趣细粒度多重判定</div>
        </div>
      </div>
      <div class="my-preponderance-banner theThird">
        <div class="banner-desc">
          <div class="banner-desc-box">
            <p><span class="s-title BgColor">投放数据</span></p>
            <p class="s-title1">广告投放基础数据（流量监测、效果追踪）</p>
          </div>
          <div class="banner-desc-box">
            <p><span class="s-title BgColor">落地页数据</span></p>
            <p class="s-title1">用户浏览、跳转和转化行为……</p>
          </div>
          <div class="line BgColor"></div>
          <div class="title">广告数据实时追踪</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LaAdvantage"
}
</script>

<style scoped>
.show-title {
  color: #212529;
  padding-top: 40px;
  font-size: 2rem;
  height: 80px;
  text-align: center;
}

.my-preponderance {
  width: 100%;
  color: white;
  height: 680px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  justify-items: center;
  vertical-align: center;
}

.my-preponderance-banner {
  margin-left: 30px;
  width: 500px;
  height: 660px;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090, direction=120, strength=8); /*ie*/
  -moz-box-shadow: 2px 4px 10px #909090; /*firefox*/
  -webkit-box-shadow: 4px 2px 10px #909090; /*safari或chrome*/
  box-shadow: 2px 4px 10px #909090; /*opera或ie9*/
  position: relative;
  overflow: hidden;
  border-radius: 3%;
}

.firstSheet {
  background: #ffffff url("../assets/static/chinamaps.jpg");
  background-size: 100%;
}

.theThird {
  background: #ffffff url("../assets/static/brain.jpg");
  background-size: 100%;
}

.brain {
  background: #ffffff url("../assets/static/theThird.jpg");
  background-size: 100%;
}

.line {
  width: 100%;
  height: 100px;
  background: #1afa29;
  position: absolute;
  bottom: 0%;
  transition: 0.3s;
}

.my-preponderance-banner:hover .line {
  position: absolute;
  transform: scaleY(7);
  opacity: 40%;
}

.title {
  position: absolute;
  color: white;
  bottom: 7%;
  left: 50%;
  font-size: 20px;
  transform: translateX(-50%);
}

.banner-desc {
  height: 200px;
  color: #212529;
  text-align: left;
}

.banner-desc-box {
  margin-top: 50px;
}

.s-title {
  font-size: 20px;
  padding-left: 5px;
  padding-right: 5px;
  color: #ffffff;
  background-color: #1afa29;
}
.s-title1{
  color: #ffffff;
}

.BgColor {
  background: #8062ff;
}

.BgColor-two {
  background: #27e0ae;
}
</style>